<template>
  <div id="builder"></div>
</template>

<script>
import TemplateBuilder from "./components/TemplateBuilder/index";

export default {
  name: "VueTemplateBuilder",
  props: {
    container: {
      type: [String, HTMLElement], // Updated to allow both string and HTMLElement
      required: true
    },
    secretKey: {
      type: String,
      required: true
    },
    publicApiKey: {
      type: String,
      required: true
    },
    platformName: {
      type: String,
      required: false
    },
    templateGalleryModal: {
      type: Boolean,
      required: false
    },
    createTemplateRoute: {
      type: String,
      required: false
    },
    templateBuilderRoute: {
      type: String,
      required: false
    },
    olcTemplate: {
      type: Object,
      required: false
    },
    designerTemplateQuery: {
      type: Object,
      required: false
    },
    sandbox: {
      type: Boolean,
      required: false
    },
    allowSenderFields: {
      type: Boolean,
      required: false
    },
    allowPropertyFields: {
      type: Boolean,
      required: false
    },
    excludedFields: {
      type: String,
      default: null,
      required: false,
    },
    designerQueryAmount: {
      type: String | Number,
      default: null,
      required: false,
    },
    allowedAddOns: {
      type: [String],
      default: null,
      required: false,
    },
    allowedTemplateSections:{ 
      type: [String],
      default: null,
      required: false,
    },
    env: {
      type: String,
      default: null,
      required: false,
    },
    restrictedProducts: {
      type: [Number],
      default: null,
      required: false,
    },
    onReturnAndNavigate: {
      type: Function,
      required: false
    },
    onCreateCustomTemplateQuery: {
      type: Function,
      required: false
    },
    onGetOneTemplate: {
      type: Function,
      required: false
    },
    onGetTemplates: {
      type: Function,
      required: false
    },
    onGetCustomFields: {
      type: Function,
      required: false
    },
    onDuplicateTemplate: {
      type: Function,
      required: false
    },
    onSubmit: {
      type: Function,
      required: false,
    },
    styles: {
      type: Object,
      required: false,
    }
  },
  data() {
		return {
			templateBuilderVueInstance: null,
		};
	},
  mounted() {
    let vm = this;
    console.log('vm', vm);
    this.initializeEditor(vm);
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  destroyed() {
    this.templateBuilderVueInstance.destroy();
  },

  methods: {
    initializeEditor(props) {
      this.templateBuilderVueInstance = TemplateBuilder({
        container: document.getElementById(props.container) || document.getElementById('builder'),
        secretKey: props.secretKey,
        publicApiKey: props.publicApiKey,
        platformName: props.platformName,
        templateGalleryModal: props.templateGalleryModal,
        createTemplateRoute: props.createTemplateRoute,
        templateBuilderRoute: props.templateBuilderRoute,
        olcTemplate: props.olcTemplate,
        designerTemplateQuery: props.designerTemplateQuery,
        sandbox: props.sandbox,
        allowSenderFields: props.allowSenderFields,
        allowPropertyFields: props.allowPropertyFields,
        excludedFields: props.excludedFields,
        designerQueryAmount: props.designerQueryAmount,
        allowedAddOns: props.allowedAddOns,
        allowedTemplateSections: props.allowedTemplateSections,
        env: props.env,
        restrictedProducts: props.restrictedProducts,
        onReturnAndNavigate: props.onReturnAndNavigate, 
        onCreateCustomTemplateQuery: props.onCreateCustomTemplateQuery,
        onGetOneTemplate: props.onGetOneTemplate,
        onGetTemplates: props.onGetTemplates,
        onGetCustomFields: props.onGetCustomFields,
        onDuplicateTemplate: props.onDuplicateTemplate,
        onSubmit: props.onSubmit,
        styles: props.styles,
      });
    }
  }
};
</script>